module.exports = __webpack_public_path__ + "img/Sornek3.12dd9aa2.webp";